module.exports = __webpack_public_path__ + "img/grs.f366d474.svg";